import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"filter\"><path d=\"M256 0C114.615 0 0 35.817 0 80v48l192 192v160c0 17.673 28.653 32 64 32s64-14.327 64-32V320l192-192V80c0-44.183-114.615-80-256-80zM47.192 69.412c11.972-6.829 28.791-13.31 48.639-18.744C139.803 38.63 196.685 32 256 32s116.197 6.63 160.169 18.668c19.848 5.434 36.667 11.915 48.64 18.744 7.896 4.503 12.162 8.312 14.148 10.588-1.986 2.276-6.253 6.084-14.148 10.588-11.973 6.829-28.792 13.31-48.64 18.744C372.198 121.37 315.315 128 256 128s-116.197-6.63-160.169-18.668c-19.848-5.434-36.667-11.915-48.639-18.744C39.296 86.084 35.03 82.276 33.043 80c1.987-2.276 6.253-6.084 14.149-10.588z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/filter.svg
// module id = En+b
// module chunks = 1